import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6cc5cb4f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护故障类型信息")], -1));
const _hoisted_3 = {
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, " 故障类型标签 ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}故障类型`), 1)]), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "故障类型名称",
        prop: "name"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.name = $event),
          placeholder: "请输入故障类型名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "图片"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          "file-list": $data.formModel.imgs,
          "onUpdate:fileList": _cache[1] || (_cache[1] = $event => $data.formModel.imgs = $event),
          class: _normalizeClass($data.formModel.imgs.length > 0 ? 'disabledImg' : ''),
          action: "",
          limit: "1",
          "list-type": "picture-card",
          "on-change": $options.changeFile,
          "on-preview": $options.handlePictureCardPreview,
          "before-remove": $options.beforeRemove,
          "auto-upload": false
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "iconfont icon-file-add"
          })]),
          _: 1
        }, 8, ["file-list", "class", "on-change", "on-preview", "before-remove"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_divider), _createVNode(_component_el_table, {
        data: $data.formModel.initItem,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "阶梯",
          width: "70px",
          prop: "seq"
        }), _createVNode(_component_el_table_column, {
          label: "标签名称"
        }, {
          default: _withCtx(scope => [_withDirectives(_createElementVNode("p", null, _toDisplayString(scope.row.itemName), 513), [[_vShow, !scope.row.editable]]), _withDirectives(_createVNode(_component_el_input, {
            modelValue: scope.row.itemName,
            "onUpdate:modelValue": $event => scope.row.itemName = $event
          }, null, 8, ["modelValue", "onUpdate:modelValue"]), [[_vShow, scope.row.editable]])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [scope.row.editable ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            onClick: $event => scope.row.editable = false,
            type: "success"
          }, {
            default: _withCtx(() => [_createTextVNode("确定 ")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), !scope.row.editable ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            link: "",
            onClick: $event => scope.row.editable = true,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("修改 ")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            link: "",
            onClick: $event => $options.deleteItem(scope.row),
            type: "danger"
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $options.addItem
        }, {
          default: _withCtx(() => [_createTextVNode("增加标签 ")]),
          _: 1
        }, 8, ["onClick"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存 ")]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['faultInfo_add', 'faultInfo_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  })]);
}